import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { StaticMenuProvider, useStaticMenuContext } from 'state/static-menu';
import { useStoreContext } from 'state/store';

import { MainMenuProvider, useMainMenuContext } from '../main-menu';
import { MenuOptionsProvider, useMenuOptionsContext } from '../menu-options';
import { MenuUIProvider } from '../menu-ui';

export type Menu = ReturnType<typeof useMainMenuContext> &
  ReturnType<typeof useMenuOptionsContext> &
  ReturnType<typeof useStaticMenuContext> & { showStaticMenu: boolean };

export const useMenuContext = (): Menu => {
  const mainMenu = useMainMenuContext();
  const menu = useMenuOptionsContext();
  const staticMenuData = useStaticMenuContext();
  const enableStaticMenu = useFlag(LaunchDarklyFlag.ENABLE_STATIC_MENU);
  const { isStoreOpenAndAvailable, store } = useStoreContext();

  const showStaticMenu =
    enableStaticMenu && (!isStoreOpenAndAvailable || store.hasMobileOrdering === false);

  return {
    ...menu,
    ...mainMenu,
    ...staticMenuData,
    showStaticMenu,
  };
};

export const MenuProvider = ({ children }: IBaseProps) => {
  return (
    <MainMenuProvider>
      <MenuOptionsProvider>
        <StaticMenuProvider>
          <MenuUIProvider>{children}</MenuUIProvider>
        </StaticMenuProvider>
      </MenuOptionsProvider>
    </MainMenuProvider>
  );
};
